// @charset "utf-8";
export default {
    backtest: {
        index: {
            beginButton: '开始回测',
            restartButton: '再次回测',
            loadingButton: '计算中…'
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/staticText.js